module.exports = __webpack_public_path__ + "static/media/Lab_Partner_2_PCR_Product.78c21c31.svg";